
<icon
  v-if="!hideHelp"
  name="help_outline"
  class="help-icon"
  v-tooltip="{ content: helpText, delay: 100, placement: 'bottom' }"
/>
